import { http } from './client';
export interface FinalInvoiceFollowup {
  pending: boolean; urgent: boolean; overdue: boolean; endedAt: string; dueAt: string; timezone: string;
  endSource: 'show_end_day'; hoursRemaining: number; deadlineLabel: string; reasons: string[];
  invoices: Array<{ configurationId: string | null; name: string; invoiceId: string | null; invoiceNumber: string | null;
    status: string; label: string; pending: boolean; sentAt: string | null }>;
}
export interface FinalInvoiceFollowupShow { eventId: string; eventName: string; approved: boolean; finalInvoiceFollowup: FinalInvoiceFollowup }
export async function loadFinalInvoiceFollowups(): Promise<{shows:FinalInvoiceFollowupShow[];truncated:boolean;lookbackDays:number}> {
  const {response,error}=await http({method:'GET',url:'dashboard/final-invoice-followup',isToken:true});
  if(error)throw error;
  const data=response?.data?.data??response?.data;
  return {shows:Array.isArray(data?.shows)?data.shows:[],truncated:data?.truncated===true,lookbackDays:data?.lookbackDays??120};
}
